import Model from "~/models/_Model";
import System from "./System";
import Task from "./Task";
import dayjs from "dayjs";

export default class File extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/systemsmanager";
  }

  primaryKey() {
    return "path";
  }

  // Set the resource route of the model
  resource() {
    return "files";
  }

  relations() {
    return {
      //system: System,
      //task: Task,
    };
  }
}
